var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('app-page-top-section',{attrs:{"title":_vm.$t('black_list'),"icon":"message-circle","directory":_vm.$t('subscribers')}}),_vm._v(" "),_c('app-subscribers',_vm._b({},'app-subscribers',_vm.$data.rules,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }